import { useI18n } from '@alife/panda-i18n';
import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { store } from '@ice/stark-data';
import { CnButton } from '@alife/cn-ui';
import ReleaseNote from './components/release-note';
import HelpCenter from './components/help-center';
import HotQuestion from './components/hot-question';
import HotFeedback from './components/hot-feedback';
import HelpCard from './components/help-card';
import Survey from './components/survey';
import SelfTool from './components/self-tool';
import { PanelType, } from 'src/types';
import './index.scss';
import { execSlot } from 'src/utils';
import { gotoWorkOrder } from '../feedback';
// const CompMap: PanelComponentMapProps = {
//     releaseNotes: ReleaseNote,
//     helpCenter: HelpCenter,
//     hotQuestion: HotQuestion,
// };
export default function Panel(props) {
    const { config, panelCode, ...restProps } = props;
    const $i18n = useI18n();
    const featureMap = useMemo(() => {
        return (config.xlPanelConfigDTOList?.reduce((map, prev) => {
            map[prev.panelConfigCode] = prev;
            return map;
        }, {}) || {});
    }, [config.xlPanelConfigDTOList]);
    const listItems = useMemo(() => {
        const typeList = [];
        const list = [
            {
                type: 'onlineService',
                icon: 'https://img.alicdn.com/imgextra/i2/O1CN01kVqi0O1HvbXVRk2Rg_!!6000000000820-2-tps-96-96.png',
                title: $i18n.get({ id: 'OnlineServiceTitle', dm: '在线服务' }),
                desc: $i18n.get({
                    id: 'AskMeIfYouHaveAnyQuestions',
                    dm: '有问题找我解答',
                }),
                canClick: true,
            },
            {
                type: 'hotline',
                icon: 'https://img.alicdn.com/imgextra/i1/O1CN01ZgITLE1mriGUc4bVS_!!6000000005008-2-tps-96-96.png',
                title: $i18n.get({ id: 'HotlineService', dm: '热线服务' }),
                desc: '1666-2',
                canClick: false,
            },
            {
                type: 'feedback',
                icon: 'https://img.alicdn.com/imgextra/i2/O1CN01TfVa2d1xLcHVuAKdZ_!!6000000006427-2-tps-96-96.png',
                title: $i18n.get({ id: 'FeedbackTitle', dm: '反馈&建议' }),
                desc: $i18n.get({
                    id: 'SystemOperationConsultationAndProductRequirement_1424026647',
                    dm: '系统操作咨询和产品需求反馈',
                }),
                canClick: true,
            },
        ]
            .filter((item) => {
            typeList.push(item.type);
            const data = featureMap[item.type];
            if (item.type === PanelType.onlineService && !data?.data?.accessUrl) {
                return false;
            }
            return data;
        })
            .map((item) => {
            let desc = item.type === 'hotline'
                ? featureMap[item.type]?.data?.hotlineText
                : item.desc;
            if (item.type === PanelType.feedback && featureMap[item.type]?.data?.caseType === 'baseCase' && typeof desc === 'string') {
                desc = React.createElement("span", null,
                    desc,
                    " ",
                    React.createElement(CnButton, { type: "primary", className: "cn-ui-intelli-assistant-panel-item-desc-btn", text: true, onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            gotoWorkOrder({
                                env: props.env,
                                userSystem: props.userSystem,
                                linkCode: featureMap[item.type]?.data?.baseCaseLinkCode
                            });
                        } }, $i18n.get({
                        id: 'ViewMyFeedback',
                        dm: '查看我的反馈',
                    })));
            }
            return {
                ...item,
                desc,
                data: featureMap[item.type]?.data,
                onClick() {
                    if (item.type === 'hotline')
                        return;
                    props.onTypeClick(item.type, featureMap[item.type]?.data);
                },
            };
        });
        const customList = execSlot(store.get('cn-assistant-custom-quick-entry'), 'cn-assistant-custom-quick-entry', config) || [];
        if (customList.length) {
            const newList = [];
            const typeMap = list.reduce((prev, cur) => {
                prev[cur.type] = cur;
                return prev;
            }, {});
            const insertTypeMap = {};
            // 给自定义 插槽分组
            customList.forEach((item) => {
                item.desc = item.description;
                item.canClick = item.hasArrow;
                if (!insertTypeMap[item.anchor]) {
                    insertTypeMap[item.anchor] = {
                        up: [],
                        down: []
                    };
                }
                insertTypeMap[item.anchor][item.position]?.push(item);
            });
            // 插入自定义插槽
            typeList.forEach((type) => {
                const currentTypeMap = insertTypeMap[type];
                const currentTypeData = typeMap[type];
                const pushCurrentData = () => {
                    currentTypeData && newList.push(currentTypeData);
                };
                if (currentTypeMap) {
                    newList.push(...currentTypeMap.up);
                    pushCurrentData();
                    newList.push(...currentTypeMap.down);
                }
                else {
                    pushCurrentData();
                }
            });
            return newList;
        }
        return list;
    }, [featureMap]);
    const findQuestion = useMemo(() => {
        return config.xlPanelConfigDTOList.filter((m) => m?.panelConfigCode === PanelType.questionnaire);
    }, [config.xlPanelConfigDTOList]);
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-panel`, onClick: (e) => e.stopPropagation() },
        React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-title' },
            React.createElement("img", { src: 'https://img.alicdn.com/imgextra/i4/O1CN01Z4U8Jn1kQZbKo8p8r_!!6000000004678-2-tps-236-236.png', style: { width: 46, height: 46 } }),
            React.createElement("span", { "data-i18n-ignore": true }, $i18n.get({ id: 'XiaoLing', dm: '小灵' })),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-hint' },
                "hi",
                ' ',
                parseInt(dayjs(new Date()).format('HH')) > 12
                    ? $i18n.get({ id: 'GoodAfternoon', dm: '下午好' })
                    : $i18n.get({ id: 'GoodMorning', dm: '上午好' }),
                $i18n.get({ id: 'WelcomeToConsult', dm: '，欢迎咨询！' }))),
        execSlot(store.get('cn-assistant-top-slot'), 'exec cn-assistant-top-slot fail', config),
        !!(featureMap.helpCenter) && (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-item' },
            React.createElement(HelpCenter, { panelConfig: config.xlPanelConfigDTOList, data: featureMap, panelCode: panelCode, onItemClick: props.onTypeClick }))),
        !!featureMap.selfTools?.data?.selfToolsConfig?.length && (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-item' },
            React.createElement(SelfTool, { panelConfig: config.xlPanelConfigDTOList, list: featureMap.selfTools?.data?.selfToolsConfig, panelCode: panelCode, onItemClick: props.onTypeClick }))),
        !!featureMap.hotFeedback?.data?.xlFeedBackDTOList?.length && (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-item' },
            React.createElement(HotFeedback, { panelConfig: config.xlPanelConfigDTOList, config: config, ...restProps, linkCode: featureMap[PanelType.feedback]?.data?.baseCaseLinkCode, list: featureMap.hotFeedback?.data?.xlFeedBackDTOList, panelCode: panelCode }))),
        !!(featureMap.hotQuestion) && (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-item' },
            React.createElement(HotQuestion, { panelConfig: config.xlPanelConfigDTOList, data: featureMap, panelCode: panelCode, ...restProps, onItemClick: props.onTypeClick }))),
        !!featureMap.releaseNotes && featureMap.releaseNotes.data && (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-item' },
            React.createElement(ReleaseNote, { panelConfig: config.xlPanelConfigDTOList, data: featureMap.releaseNotes.data, panelConfigCode: featureMap.releaseNotes.panelConfigCode, panelCode: panelCode, onItemClick: props.onTypeClick }))),
        listItems.length ? React.createElement(HelpCard, { data: listItems, panelCode: panelCode }) : null,
        findQuestion?.[0]?.data ? React.createElement(Survey, { data: findQuestion[0]?.data, onItemClick: props.onTypeClick, panelCode: panelCode }) : null));
}
